module.exports = __webpack_public_path__ + "static/media/kazing.efe199b6.svg";